/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExclusionTermCreatedByUser
 */
export interface ExclusionTermCreatedByUser {
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
}

/**
 * Check if a given object implements the ExclusionTermCreatedByUser interface.
 */
export function instanceOfExclusionTermCreatedByUser(value: object): value is ExclusionTermCreatedByUser {
    return true;
}

export function ExclusionTermCreatedByUserFromJSON(json: any): ExclusionTermCreatedByUser {
    return ExclusionTermCreatedByUserFromJSONTyped(json, false);
}

export function ExclusionTermCreatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExclusionTermCreatedByUser {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function ExclusionTermCreatedByUserToJSON(json: any): ExclusionTermCreatedByUser {
    return ExclusionTermCreatedByUserToJSONTyped(json, false);
}

export function ExclusionTermCreatedByUserToJSONTyped(value?: ExclusionTermCreatedByUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

